exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboard-slide-item__card-container{display:flex;margin:4px 4px}@media only screen and (min-width: 768px){.dashboard-slide-item__card-container{justify-content:center;margin:4px auto}}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};